import { useFeatureGate } from "@statsig/react-bindings";
import { useSelectedChatChannel } from "./SelectedChannel";
import { useChat } from "../ChimeChatProvider";
import { useMemo } from "react";

/**
 * This allows for easy switching between the legacy Chime implementation and the new API implementation.
 */
export const useChatImplementation = () => {
  // https://console.statsig.com/1VGSmMANGPRe7F43MDlnJk/gates/web_chat_api
  const gate = useFeatureGate("web_chat_api");

  return {
    useApiChat: gate.value,
  };
};

export const useEnableParallelChatAPICalls = () => {
  // https://console.statsig.com/1VGSmMANGPRe7F43MDlnJk/gates/web_chat_api_parallel_calls
  const gate = useFeatureGate("web_chat_api_parallel_calls");
  // So if new chat is enabled, we enable the API calls for it
  const { useApiChat } = useChatImplementation();

  return {
    enableChatAPICalls: useApiChat || gate.value,
  };
};

export const useSelectedChatChannelRespondentId = () => {
  const { useApiChat } = useChatImplementation();
  const { selectedChatChannel: apiSelectedChatChannel } =
    useSelectedChatChannel();
  const { selectedConversation: chimeSelectedConversation } = useChat();

  return useMemo(() => {
    if (!useApiChat) {
      return chimeSelectedConversation?.respondent.patientOrProviderId;
    } else {
      return apiSelectedChatChannel?.respondent.id;
    }
  }, [useApiChat, chimeSelectedConversation, apiSelectedChatChannel]);
};
